/* eslint-disable radix */
import React, { useEffect, useContext, useRef, useCallback, useState } from 'react';
import tinycolor from 'tinycolor2';
import { useLocation } from 'react-router-dom';
import { breakpoints } from '../../../../config/constants';
import Intersect from '../../../Intersect';
import DecodeGlobalContext from '../../../../redux/decodeGlobalContext';
import gtmPush from '../../../../helpers/gtmPush';

import './styles.scss';
import {
  SET_NAVIGATION_MENU_BACKGROUND,
  SET_NAVIGATION_PAGINATION,
  SET_PREVIOUS_ARTICLE_FOCUS
} from '../../../../redux/actionTypes';

const ArticleCardBase = ({ children, variation, accentColor1 = '', endCard }) => {
  const { state, dispatch } = useContext(DecodeGlobalContext);
  const { navPagination } = state;
  const baseCardIntersetRef = useRef();
  const navPaginationRef = useRef(navPagination);
  const [, setPreviousArticleFocus] = useState('');
  const location = useLocation();

  useEffect(() => {
    // Update the navPaginationRef when global context/state changes.
    navPaginationRef.current = navPagination;
  }, [navPagination]);

  useEffect(() => {
    const { pathname } = location || {};

    if (pathname.includes('article')) {
      setPreviousArticleFocus(pathname.replace('/decode/article/', ''));
    }
  }, [location]);

  useEffect(() => {
    dispatch({
      type: SET_PREVIOUS_ARTICLE_FOCUS,
      payload: location.pathname.split('/').pop()
    });
  }, []);

  const onCardIntersection = entry => {
    if (!entry.isIntersecting) return;

    const isMobileOrTablet = window.innerWidth < breakpoints.smallDesktop;

    if (isMobileOrTablet) {
      const parsedColor = tinycolor(accentColor1);
      const currentCardParent = entry.target.offsetParent;
      const { cardIndex } = currentCardParent.dataset;

      dispatch({
        type: SET_NAVIGATION_MENU_BACKGROUND,
        payload: parsedColor.isLight() || accentColor1 === '' ? 'black' : 'white'
      });

      if (cardIndex) {
        dispatch({
          type: SET_NAVIGATION_PAGINATION,
          payload: {
            page: parseInt(cardIndex),
            total: navPaginationRef.current.total
          }
        });
      }
    }
  };

  return (
    <Intersect
      active
      config={{
        root: null,
        margin: '0px',
        threshold: [1, 1]
      }}
      onIntersection={entry => onCardIntersection(entry[0])}
      elementRef={baseCardIntersetRef}>
      <section
        className={`article-card-base article-card-base--${variation}`}
        style={{ backgroundColor: accentColor1 }}>
        <span ref={baseCardIntersetRef} className="article-card-base__intersect-ref" />
        {endCard && <EndCardIntersection />}
        {children}
      </section>
    </Intersect>
  );
};

const EndCardIntersection = () => {
  const location = useLocation();
  const isGTMSent = useRef(false);

  const onCardIntersection = useCallback(entry => {
    if (!entry.isIntersecting) return;

    if (!isGTMSent.current) {
      isGTMSent.current = true;
      setTimeout(() => {
        gtmPush({
          event: 'endOfArticleReached',
          entrySlug: location.pathname
        });
      });
    }
  }, []);

  return (
    <Intersect
      active
      config={{
        root: null,
        margin: '0px',
        threshold: [1, 1]
      }}
      onIntersection={entry => onCardIntersection(entry[0])}>
      <span className="article-card-base__intersect-end" />
    </Intersect>
  );
};

export default ArticleCardBase;
